<template>
  <div>
    <h2>Recovery codes</h2>
    <div class="mb-2">
      In case you lose access to your authenticator app you can use one of these
      codes in place of the 2FA code. <b>Each code is one-time use</b>, and
      there are 10 codes. New codes can be generated in the Security section of
      your Account Settings.
    </div>
    <b-row class="my-4 w-50 mx-auto font-xl text-monospace text-center">
      <b-col v-for="code in codes" :key="code" sm="6">
        {{ code }}
      </b-col>
    </b-row>
    <div class="text-center">
      <b>This is your only chance to view these codes.</b><br />
      Please download or copy these codes and keep them safe.
    </div>
    <div class="d-flex mt-4 text-right">
      <b-button
        :variant="downloaded ? 'primary' : 'secondary'"
        class="px-4 mr-auto"
        @click="$emit('close')"
      >
        Close
      </b-button>
      <b-button
        :variant="downloaded ? 'success' : 'primary'"
        class="px-4"
        @click="downloadCodes"
      >
        <i :class="`fa fa-${downloaded ? 'check' : 'download'}`"></i>
        Download{{ downloaded ? "ed" : "" }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { downloadText } from "@/helpers/download";

export default {
  computed: mapState(["user"]),

  props: {
    codes: Array
  },

  data: () => ({
    downloaded: false
  }),

  methods: {
    downloadCodes() {
      const filename = `Nanome Recovery Codes - ${this.user.email}.txt`;
      const content = [
        "Nanome Recovery Codes",
        this.user.email,
        new Date().toLocaleString(),
        "",
        "--------",
        ...this.codes,
        "--------"
      ].join("\n");
      downloadText(filename, content);
      this.downloaded = true;
    }
  }
};
</script>
